export default __webpack_public_path__ + "static/media/330_portfolio04-fr-mobile.a0e99be0.png";